import { FC, useState } from "react";
import classes from "./SystemStatus.module.css";
import { convertValueToFieldState, isFieldStateBlinking } from "../../app/TagValueConverters";
import FieldStateDataPoint from "../../banner/FieldStateDataPoint";
import SystemStatusIcons from "../../banner/SystemStatusIcons";
import { Tags } from "../../data_point/tags/TagCatalog";
import { AuxiliariesStatusIcons } from "../../../SolarGikLib/icons/IconsModels";
import SafeOverrideTooltip from "./SafeOverrideTooltip";
import { useSystemStatusDescription } from "../../system_status/useSystemStatusDescription";

interface ISystemStatusProps {
  siteId: string;
  canControlTrackers: boolean;
  hasTrackers: boolean;
}
const SystemStatus: FC<ISystemStatusProps> = ({ siteId, canControlTrackers, hasTrackers }) => {
  const { invertersIssusDescription, trackersIssuesDescription } = useSystemStatusDescription(siteId);
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);
  return (
    <div className={classes.row}>
      {canControlTrackers && (
        <div className={classes["field-state-container"]}>
          <FieldStateDataPoint
            tagName={Tags.Portal.System.FieldState.logicalName}
            siteId={siteId}
            titleOverride={"Field State:"}
            valueToStringFuncOverride={convertValueToFieldState}
            isBlinkingFunc={isFieldStateBlinking}
          />
          <SafeOverrideTooltip isOpen={isTooltipOpen} setIsOpen={setIsTooltipOpen} siteId={siteId} />
        </div>
      )}
      <SystemStatusIcons
        systemItems={[
          ...(hasTrackers
            ? [
                {
                  tagName: Tags.Portal.TrackerStatus.SystemStatus.logicalName,
                  icon: AuxiliariesStatusIcons.Tracker,
                  description: trackersIssuesDescription,
                },
              ]
            : []),
          {
            tagName: Tags.Portal.Inverter.SystemStatus.logicalName,
            icon: AuxiliariesStatusIcons.Inverter,
            description: invertersIssusDescription,
          },
        ]}
      />
    </div>
  );
};
export default SystemStatus;
